import {
  call,
  takeLatest,
} from 'redux-saga/effects';

import {
  sendFollowUpEmail as sendFollowUpEmailAction,
} from 'actions/follow-up-email';

import {
  sendFollowUpEmailApi,
} from 'services/follow-up-email';

import fetchEntity from './fetch-entity';

const sendFollowUpEmail = fetchEntity.bind(
  null,
  sendFollowUpEmailAction.actions,
  sendFollowUpEmailApi,
);

export function* loadSendFollowUpEmail({ params }) {
  yield call(sendFollowUpEmail, {
    ...params,
  });
}

function* watchSendFollowUpEmail() {
  yield takeLatest(
    sendFollowUpEmailAction.actionName,
    loadSendFollowUpEmail,
  );
}

export default {
  watchSendFollowUpEmail,
};
